// 找到节点数据并回调处理节点方法 callback回调: node-当前节点 i-当前节点序号 data-包含当前节点的节点组 parentNode 当前节点父节点
export const loop = (
    data: any,
    key: React.Key,
    callback: (node: any, i: number, data: any, parent?: any) => void,
    parentNode?: any,
) => {
    for (let i = 0; i < data.length; i++) {
        if (data[i].key === key) {
            return callback(data[i], i, data, parentNode);
        }
        if (data[i].children) {
            loop(data[i].children!, key, callback, data[i]);
        }
    }
};

export const loopRemove = (data, key) => {
    for (var i = 0; i < data.length; i++) {
        var item = data[i];
        if (item.isFolder) {
            for (var j = 0; j < item.children.length; j++) {
                var subItem = item.children[j];
                if (subItem.key === key) {
                    item.children.splice(j, 1);
                    return subItem;
                }
            }
        } else {
            if (item.key === key) {
                data.splice(i, 1);
                return item;
            }
        }
    }
}

/**
 * 遍历所有节点并回调....
 * @param data
 * @param callback
 */
export const loopAllNode = (data:any,callback:any)=>{
    for (let i = 0; i < data.length; i++) {
        if (data[i].children) {
            loopAllNode(data[i].children,callback);
        }
        callback(data[i]);
    }
}

/**
 * 遍历所有节点并回调....
 * @param data
 * @param callback
 */
export const loopAllNodeWithReturn = (data:any,callback:any)=>{
    for (let i = 0; i < data.length; i++) {
        if (data[i].children) {
            loopAllNode(data[i].children,callback);
        }
        const isContinue = callback(data[i]);
        if (!isContinue){
            break;
        }
    }
}

export const loopAllNodeAsync = async (data:any,callback:any)=>{
    for (let i = 0; i < data.length; i++) {
        if (data[i].children) {
            await loopAllNodeAsync(data[i].children,callback);
        }
        await callback(data[i]);
    }
}

/**
 * 取节点的level
 * 0顶级  1子级  2三级
 * @param data
 * @param node
 */
export const findNodeLevel = (treeData:any,targetKey:any,currentLevel = 0)=>{
    for (const node of treeData) {
        if (node.key === targetKey) {
            return currentLevel;
        }

        if (node.children && node.children.length > 0) {
            const level = findNodeLevel(node.children, targetKey, currentLevel + 1);
            if (level !== -1) {
                return level;
            }
        }
    }

    return -1; // 未找到
}

/**
 * 查询找有父节点----
 * @param tree
 * @param targetKey
 * @param currentLevel
 * @param parents
 */
export function findNodeWithParents(treeData, targetKey) {
    function search(nodes, currentPath = []) {
        for (const node of nodes) {
            // 找到目标节点时返回结果
            if (node.key === targetKey) {
                return {
                    node: node,
                    level: currentPath.length, // 当前路径长度就是层级
                    parents: [...currentPath], // 父节点数组
                    fullPath: [...currentPath.map(p => p.key), node.key] // 完整路径
                };
            }

            // 如果有子节点，继续递归搜索
            if (node.children && node.children.length > 0) {
                const result = search(node.children, [...currentPath, node]);
                if (result) return result;
            }
        }
        return null;
    }

    return search(treeData);
}

export function isKeyInTree(treeData, targetKey) {
    for (const node of treeData) {
        if (node.key === targetKey) {
            return true;
        }
        if (node.children && node.children.length > 0) {
            if (isKeyInTree(node.children, targetKey)) {
                return true;
            }
        }
    }
    return false;
}

/**
 * 所有folder的文件夹数量
 * @param data
 */
export const getFolderCount = (data:any)=>{
    let nFolderCount = 0;
    loopAllNode(data,(node)=>{
        if (node.isFolder){
            nFolderCount ++;
        }
    })
    return nFolderCount;
}

/**
 * 搜索树
 * @param nodes
 * @param searchValue
 */
export const filterNodes = (nodes,searchValue) => {
    return nodes
        .map(node => ({ ...node }))
        .filter(node => {
            const titleMatch = node.title.toLowerCase().includes(searchValue.toLowerCase());
            if (titleMatch) return true;

            if (node.children) {
                const children = filterNodes(node.children,searchValue);
                node.children = children.length ? children : null;
                return children.length > 0;
            }
            return false;
        });
};


export function filterPublishCheckedTreeData(data) {
    if (!Array.isArray(data)) {
        return data;
    }

    return data.reduce((acc, node) => {
        // 1. 检查当前节点是否应该被保留
        // 如果字段不存在 或 值为 true，则保留进行后续处理
        const isChecked = node.isPublishChecked !== false;

        if (!isChecked) {
            // 如果 isPublishChecked 为 false，直接跳过（删除）
            return acc;
        }

        // 2. 创建新节点副本，避免修改原数据
        const newNode = { ...node };

        // 3. 递归处理子节点 (如果存在)
        if (newNode.children && Array.isArray(newNode.children)) {
            newNode.children = filterPublishCheckedTreeData(newNode.children);
        }

        // 4. 父级清理规则：
        // 如果是文件夹，且处理后 children 为空，则不加入结果集（相当于删除该父级）
        if (newNode.isFolder && (!newNode.children || newNode.children.length === 0)) {
            return acc;
        }

        // 5. 将处理后的节点加入结果集
        acc.push(newNode);
        return acc;
    }, []);
}

























